import React from "react"
import { Stack } from "@chakra-ui/react"
import MenuItem from "./MenuItem"

export default function Links(props) {
  return (
    <Stack
    spacing={1}
    align="center"
    justify={["center", "space-between", "flex-end", "flex-end"]}
    direction={["column", "column", "row", "row"]}
    pt={[4, 4, 0, 0]}
    >
    <MenuItem page="about">About</MenuItem>
    <MenuItem page="experience">Experience</MenuItem>
    <MenuItem page="activities">Activities</MenuItem>
    <MenuItem page="skills">Skills</MenuItem>
    <MenuItem page="projects">Projects</MenuItem>
    </Stack>
  )
}
